import storage from "@/utils/storage";

// URLからキーを吸い出す
function getUrlKey() {
  var url = new URL(window.location.href);
  var params = url.searchParams;
  var key = params.get("key");
  return key;
}

// URLを優先的に参照する
export const getToken = () => {
  const tokenByURL = getUrlKey();
  if (tokenByURL !== null) {
    storage.setToken(tokenByURL);
    return tokenByURL;
  }
  const tokenByStorage = storage.getToken();
  if (tokenByStorage !== null) return tokenByStorage;

  return null;
};
